import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'users' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: 'inbox',
          name: 'inbox',
          component: () =>
            import(/* webpackChunkName: "inbox" */ '@/views/Home/Inbox')
        },
        {
          path: 'users',
          name: 'users',
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Home/Users')
        },
        // {
        //   path: 'users/add',
        //   name: 'user.create',
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "user.create" */ '@/views/Home/Users/UserCreate'
        //     )
        // },
        {
          path: 'users/:id',
          name: 'user.details',
          component: () =>
            import(
              /* webpackChunkName: "user.details" */ '@/views/Home/Users/UserDetails'
            )
        },
        {
          path: 'users/:id/tools/:toolId',
          name: 'user.tool.details',
          component: () =>
            import(
              /* webpackChunkName: "user.tool.details" */ '@/views/Home/Users/Tools/ToolDetails'
            )
        },
        {
          path: 'users/:id/transactions/:transactionId',
          name: 'user.transaction.details',
          component: () =>
            import(
              /* webpackChunkName: "user.transaction.details" */ '@/views/Home/Users/Transactions/TransactionDetails'
            )
        },
        {
          path: 'faqs',
          name: 'faqs',
          component: () =>
            import(/* webpackChunkName: "faqs" */ '@/views/Home/Faqs')
        },
        {
          path: 'faqs/add',
          name: 'faq.create',
          component: () =>
            import(
              /* webpackChunkName: "faq.create" */ '@/views/Home/Faqs/FaqCreate'
            )
        },
        {
          path: 'faqs/:id',
          name: 'faq.details',
          component: () =>
            import(
              /* webpackChunkName: "faq.details" */ '@/views/Home/Faqs/FaqDetails'
            )
        },
        {
          path: 'privacy-policy',
          name: 'privacy-policy',
          component: () =>
            import(
              /* webpackChunkName: "privacy-policy" */ '@/views/Home/PrivacyPolicy'
            )
        },
        {
          path: 'terms-of-use',
          name: 'terms-of-use',
          component: () =>
            import(
              /* webpackChunkName: "terms-of-use" */ '@/views/Home/TermsOfUse'
            )
        },
        {
          path: 'notification',
          name: 'notification',
          component: () =>
            import(
              /* webpackChunkName: "push-notification" */ '@/views/Home/Notification'
            )
        }
        // {
        //   path: 'content',
        //   name: 'content',
        //   component: () =>
        //     import(/* webpackChunkName: "content" */ '@/views/Home/Content')
        // },
        // {
        //   path: 'settings',
        //   name: 'settings',
        //   component: () =>
        //     import(/* webpackChunkName: "settings" */ '@/views/Home/Settings')
        // },
        // {
        //   path: 'reports',
        //   name: 'reports',
        //   component: () =>
        //     import(/* webpackChunkName: "reports" */ '@/views/Home/Reports')
        // }
      ]
    }
  ]
})
